import Vue from 'vue'
import {
	Button,
	Cell,
	CellGroup,
	Icon,
	Col,
	Row,
	Popup,
	Toast,
	Checkbox,
	CheckboxGroup,
	Field,
	Form,
	NumberKeyboard,
	RadioGroup,
	Radio,
	Search,
	Lazyload,
	PullRefresh,
	List,
	Dialog,
	Skeleton,
	Empty,
	Tabbar,
	TabbarItem,
	Grid,
	GridItem,
	Tab,
	Tabs,
	Divider,
	NavBar,
	Popover,
	Overlay,
	Collapse,
	CollapseItem,
	Picker,
	Sidebar,
	SidebarItem,
	Loading,
	Tag,
	DropdownMenu,
	DropdownItem,
	Panel,
} from 'vant'

Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Icon)
Vue.use(Col)
Vue.use(Row)
Vue.use(Popup)
Vue.use(Toast)
Vue.use(Search)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Field)
Vue.use(Form)
Vue.use(NumberKeyboard)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Lazyload)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(Dialog)
Vue.use(Skeleton)
Vue.use(Empty)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Divider)
Vue.use(NavBar)
Vue.use(Popover)
Vue.use(Overlay)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Picker)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(Loading)
Vue.use(Tag)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Panel)
